var $ = require('jquery');
/**
 *
 */
diy.angular.registerDirective('diynotification', ['diyl10n', function(diyl10n) {
    var tpl =
        '<div class="notification-wrapper" ng-class="getNotificationClasses(notif)" ng-click="notificationAction(notif)">'+
            '<span class="notification-icon ui-icon" ng-class="notif.iconCls"></span>' +
            '<a ng-if="!notif.getSticky()" class="close-icon ui-icon ui-icon-close-small" ng-click="deleteNotification(notif.getId()); $event.stopPropagation();" title="' + diyl10n('notifications.delete') + '"></a>'+
            '<div class="notification-content standard-spacing" >' +
                '<div class="content"></div>' +
            '</div>' +
        '</div>';

    return {
        restrict: 'A',
        scope: true,
        template: tpl,
        link: function(scope, element, attrs) {
            var notification = scope.notif;

            // add content to template
            var $element = $(element);
            $element.hover(function () {
                $(this).addClass('notification-hover');
            }, function() {
                $(this).removeClass('notification-hover');
            });
            var $content = notification.getContent();
            $element.find('.content').html($content);

            scope.getNotificationContent = function() {
                var c = notification.getContent();
                if (c instanceof jQuery) {
                    return c.html();
                }
                return c;
            }

            scope.$watch(function() {
                return scope.getNotificationContent();
            }, function(n) {
                if (n) {
                    var c = notification.getContent();
                    $element.find('.content').html(c);
                }
            });

            scope.getNotificationClasses = function(notif) {
                var classes = {};
                classes['notification-type-' + notif.getCssClassSuffix()] = !!notif.getCssClassSuffix();
                classes[notif.getSeverityClass()] = true;
                classes['with-icon'] = notif.iconCls;
                classes['sticky-notification'] = notif.getSticky();
                classes['global-action'] = typeof notif.globalAction === 'function';
                return classes;
            };
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/directives/diynotification.js
 ** module id = 674
 ** module chunks = 0
 **/